import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Select } from "antd";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
const { Option } = Select;

class ClassifyCategory extends Component {
  static propTypes = {
    categoryDocuments: PropTypes.array,
    changeDocumentType: PropTypes.func,
    macro: PropTypes.string,
    subCategory: PropTypes.string,
    typeSelected: PropTypes.string
  };
  constructor(props) {
    super(props);
    this.state = {
      macroSelected: null,
      microSelected: null,
      typeSelected: null,
      tooltip: null,
      tooltipTop: 0,
      tooltipClass: "regular"
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      detailsDocument: {
        info: { details }
      },
      typeSelected
    } = nextProps;
    if (details && !prevState.typeSelected) {
      let docMacro = details.standardTags.find(el => el.key === "macrocategory");
      let docMicro = details.standardTags.find(el => el.key === "microcategory");

      return {
        ...prevState,
        macroSelected: docMacro.value,
        microSelected: docMicro.value,
        typeSelected: typeSelected
      };
    }
    if (prevState.typeSelected !== nextProps.typeSelected) {
      return {
        ...prevState,
        tooltip: "",
        tooltipTop: 0,
        tooltipClass: "regular",
        typeSelected: typeSelected
      };
    }

    return prevState;
  }

  onChangeCategory(value, e) {
    const { changeDocumentType, categoryDocuments } = this.props;
    const selectedCategory = categoryDocuments.find( category => category.id === value);

    changeDocumentType(value, e);
    this.setState({
      macroSelected: selectedCategory.macro,
      microSelected: selectedCategory.micro
    });
  }

  renderTypeDocsList() {
    const { categoryDocuments } = this.props;
    let optionList = [];

    for (let i = 0; i < categoryDocuments.length; i++) {
      optionList.push(<Option
        key={categoryDocuments[i].title}
        onClick={e => {
          this.setState({
            macroSelected: categoryDocuments[i].macro,
            microSelected: categoryDocuments[i].micro,
            typeSelected: e.key
          });
        }}
        onMouseEnter={e => {
          let tooltipCurrent = "";
          switch (e.key) {
          case "fiscale.spesometro.spesometro":
            tooltipCurrent =
                  "Spesometro, black list, Repubblica San Marino";
            break;
          case "Libro mastro":
            tooltipCurrent = "Schede o partitari contabili";
            break;
          case "Quietanze versamenti":
            tooltipCurrent = "F24, F23, rli, ecc";
            break;
          default:
            tooltipCurrent = categoryDocuments[i].title;
            break;
          }
          this.setState({
            tooltip: tooltipCurrent,
            tooltipTop: e.pageY,
            tooltipClass: "customTooltip"
          });

          /** serve a far apparire il tooltip che altrimenti non potrebbe essere renderizzato su un option */
          let elementSelect = document.getElementsByClassName("ant-select-selection__rendered")[1];
          if (elementSelect) {
            elementSelect.addEventListener(
              "mouseover",
              function() {
              },
              false
            );

            let event = new MouseEvent("mouseover", {
              view: window,
              bubbles: true,
              cancelable: true
            });

            elementSelect.dispatchEvent(event);
          }
        }}
        value={categoryDocuments[i].id}
      >
        {categoryDocuments[i].title}
      </Option>);
    }

    return (
      <Tooltip
        color={"rgb(0, 80, 117)"}
        placement="bottom"
        title={this.state.tooltip}
        overlayStyle={{ marginTop: this.state.tooltipTop }}
        overlayClassName={this.state.tooltipClass}
      >
        <Select
          onChange={(value, e) => this.onChangeCategory(value, e)}
          style={{ width: "100%" }}
          showSearch
          placeholder="Seleziona un tipo documento"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
          value={this.state.typeSelected}
        >
          {optionList}
        </Select>
      </Tooltip>
    );
  }

  render() {
    return (
      <div>
        <div style={{ float: "left" }}>
          <h2 className="subtitleSection"><FormattedMessage id="documents.classificator.titlePage" /></h2>
        </div>
        <div style={{ lineHeight: "50px" }}>
          <Tooltip
            color={"rgb(0, 80, 117)"}
            placement="topLeft"
            title={
              <div style={{ padding: "20px" }}>
                <div><FormattedMessage id="documents.classificator.titlePage" /></div>
                <div style={{ marginTop: "10px" }}>
                  <FormattedMessage id="documents.classificator.tooltip1" />
                  {" "}
                  <b><FormattedMessage id="documents.classificator.tooltip2" /></b><FormattedMessage id="documents.classificator.tooltip3" />
                </div>
              </div>
            }
          >
            <FontAwesomeIcon
              icon={["far", "info-circle"]}
              style={{ cursor: "pointer", color: "#005075" }}
            />
          </Tooltip>
        </div>
        {this.renderTypeDocsList()}
        {this.state.macroSelected && this.state.microSelected ? (
          <div style={{ marginTop: "10px" }}>
            <b><FormattedMessage id="documents.dictionary.macrocategory" />:</b> {this.state.macroSelected} <br />
            <b><FormattedMessage id="documents.dictionary.microcategory" />:</b> {this.state.microSelected}{" "}
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    categoryDocuments: state.categoryDocuments,
    detailsDocument: state.detailsDocument
  };
}

export default connect(mapStateToProps, null)(ClassifyCategory);
